module.exports = __webpack_public_path__ + "img/code.651a27ad.jpg";